import { css } from 'styled-components';

import type { Maybe } from '@/lib/types';
import { hexToRgba } from '@/theme';

export const getImageAndBackgroundStyles = (
  $backgroundColorOpacity: Maybe<string>,
  backgroundColor: Maybe<string>,
  backgroundImage: Maybe<string>,
) => {
  if ($backgroundColorOpacity && backgroundColor && backgroundImage) {
    return css`
      background-image:
        linear-gradient(
          rgba(${hexToRgba(backgroundColor, $backgroundColorOpacity)}),
          rgba(${hexToRgba(backgroundColor, $backgroundColorOpacity)})
        ),
        url(${backgroundImage});
    `;
  }

  if ($backgroundColorOpacity && backgroundColor && !backgroundImage) {
    return css`
      background-color: rgba(
        ${hexToRgba(backgroundColor, $backgroundColorOpacity)}
      );
    `;
  }

  if ($backgroundColorOpacity && !backgroundColor && backgroundImage) {
    return css`
      background-image: url(${backgroundImage});
    `;
  }
};
